import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@parchment/atoms';
import { ZoomInIcon, ZoomOutIcon, ResizeIcon } from '@parchment/icons';
var FIT_LABELS = {
  page: 'Fit to Page',
  width: 'Fit to Width'
};

var nextFit = function nextFit(fitTo) {
  return fitTo === 'page' ? 'width' : 'page';
};

export default function PdfControls(_ref) {
  var _ref$fitTo = _ref.fitTo,
      fitTo = _ref$fitTo === void 0 ? 'page' : _ref$fitTo,
      onZoomToFit = _ref.onZoomToFit,
      _ref$canZoomIn = _ref.canZoomIn,
      canZoomIn = _ref$canZoomIn === void 0 ? true : _ref$canZoomIn,
      onZoomIn = _ref.onZoomIn,
      _ref$canZoomOut = _ref.canZoomOut,
      canZoomOut = _ref$canZoomOut === void 0 ? true : _ref$canZoomOut,
      onZoomOut = _ref.onZoomOut,
      containerProps = _objectWithoutPropertiesLoose(_ref, ["fitTo", "onZoomToFit", "canZoomIn", "onZoomIn", "canZoomOut", "onZoomOut"]);

  return /*#__PURE__*/React.createElement(PdfControlsContainer, containerProps, /*#__PURE__*/React.createElement(FitToButton, {
    context: "dark",
    onClick: function onClick() {
      return onZoomToFit && onZoomToFit(nextFit(fitTo));
    },
    title: FIT_LABELS[nextFit(fitTo)],
    name: "fit-to"
  }, /*#__PURE__*/React.createElement(ResizeIcon, {
    rotate: fitTo === 'page' ? '0deg' : '180deg'
  })), fitTo === 'page' && /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(ZoomButton, {
    context: "dark",
    onClick: onZoomIn,
    title: "Zoom In",
    disabled: !canZoomIn,
    name: "zoom-in"
  }, /*#__PURE__*/React.createElement(ZoomInIcon, null)), /*#__PURE__*/React.createElement(ZoomButton, {
    context: "dark",
    onClick: onZoomOut,
    title: "Zoom Out",
    disabled: !canZoomOut,
    name: "zoom-out"
  }, /*#__PURE__*/React.createElement(ZoomOutIcon, null))));
}
PdfControls.propTypes = {
  /**
   * Whether the current view is fit to page or fit to width. Note: zoom controls are only available when fitTo == page
   */
  fitTo: PropTypes.oneOf(['page', 'width']),

  /**
   * Method invoked when clicking the "fit to page"/"fit to width" button
   */
  onZoomToFit: PropTypes.func,

  /**
   * Whether or not zoom in should be enabled
   */
  canZoomIn: PropTypes.bool,

  /**
   * Method invoked when clicking the zoom in button
   */
  onZoomIn: PropTypes.func,

  /**
   * Whether or not zoom out should be enabled
   */
  canZoomOut: PropTypes.bool,

  /**
   * Method invoked when clicking the zoom out button
   */
  onZoomOut: PropTypes.func
};
var ButtonGroup = /*#__PURE__*/styled.div.withConfig({
  displayName: "PdfControls__ButtonGroup",
  componentId: "ja6nqc-0"
})(["display:flex;margin-left:15px;"]);
var FitToButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "PdfControls__FitToButton",
  componentId: "ja6nqc-1"
})(["&.medium{padding:0 20px;}"]);
var ZoomButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "PdfControls__ZoomButton",
  componentId: "ja6nqc-2"
})(["margin:0 2px;&.medium{padding:0 20px;}"]);
var PdfControlsContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "PdfControls__PdfControlsContainer",
  componentId: "ja6nqc-3"
})(["flex:1;display:flex;flex-direction:row;flex-wrap:nowrap;white-space:nowrap;justify-content:flex-start;@media (min-width:960px){order:initial;}@media print{display:none;}"]);